<div>
  <img src="assets/img/logo.svg" alt="Generali Italia" />
  <div class="text-container">
    <h1>UNAUTHORIZED</h1>
    <h3>Non si dispongono dei permessi necessari per accedere alla pagina</h3>
  </div>
</div>
